import script from "./Markdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Markdown.vue?vue&type=script&setup=true&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=762a1ad0&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762a1ad0"]])

export default __exports__